import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Ribbon } from "@/components/Layout";
import { Search } from "lucide-react";

const eur = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export default function PiloterPaiements() {
  const nav = useNavigate();
  const [payments, setPayments] = useState([]);
  const [q, setQ] = useState("");
  const [statut, setStatut] = useState("");

  useEffect(() => { api.get("/payments").then((r) => setPayments(r.data)).catch(() => {}); }, []);

  const rows = useMemo(() => {
    const ql = q.trim().toLowerCase();
    return payments.filter((p) => {
      if (statut && p.statut !== statut) return false;
      if (ql && !`${p.patient_nom || ""} ${p.montant} ${p.moyen}`.toLowerCase().includes(ql)) return false;
      return true;
    });
  }, [payments, q, statut]);

  return (
    <div>
      <Ribbon groups={[
        { name: "Recherche", children: (
          <div className="relative">
            <Search className="w-4 h-4 text-slate-400 absolute left-2.5 top-2.5" />
            <input data-testid="pay-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Patient, montant, moyen…" className="pl-8 pr-3 py-2 w-64 rounded-lg border border-slate-300 text-sm" />
          </div>) },
        { name: "Statut", children: (
          <select data-testid="pay-statut" value={statut} onChange={(e) => setStatut(e.target.value)} className="px-2.5 py-2 rounded-lg border border-slate-300 text-sm">
            <option value="">Tous statuts</option><option value="payé">Payé</option><option value="en attente">En attente</option><option value="échoué">Échoué</option><option value="annulé">Annulé</option><option value="remboursé">Remboursé</option>
          </select>) },
      ]} />

      <div className="bg-white sx-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
            <tr><th className="text-left px-4 py-3">Date</th><th className="text-left px-4 py-3">Patient</th><th className="text-left px-4 py-3">Montant</th><th className="text-left px-4 py-3">Moyen</th><th className="text-left px-4 py-3">Statut</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">Aucun paiement.</td></tr>}
            {rows.map((p) => (
              <tr key={p.id} data-testid={`pay-row-${p.id}`} className={`border-t border-slate-100 ${p.soin_id ? "hover:bg-emerald-50/40 cursor-pointer" : ""}`} onClick={() => p.soin_id && nav(`/fiche-soin/${p.soin_id}`)}>
                <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{p.created_at ? new Date(p.created_at).toLocaleDateString("fr-FR") : "—"}</td>
                <td className="px-4 py-3 font-medium text-slate-900">{p.patient_nom || "—"}</td>
                <td className="px-4 py-3 font-medium">{eur(p.montant)}</td>
                <td className="px-4 py-3 text-slate-600">{p.moyen}</td>
                <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${p.statut === "payé" ? "bg-emerald-100 text-emerald-700" : p.statut === "échoué" ? "bg-red-100 text-red-700" : p.statut === "remboursé" ? "bg-slate-200 text-slate-700" : "bg-yellow-100 text-yellow-700"}`}>{p.statut}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
